import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { EnrollmentFormComponent } from '../enrollment-form/enrollment-form.component';

@NgModule({
  declarations: [EnrollmentFormComponent],
  exports: [EnrollmentFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatRadioModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class EnrollmentFormModule {}
